import { useContext } from 'react';
import { useSelector } from 'react-redux';

import { FormParserContext } from 'src/contexts/form.context';
import { InputContext } from 'src/contexts/input.context';
import { SearchableNestedDropdown as SearchableNestedDropdownComponent } from 'src/components/InputRenderers';
import { ifTrue } from 'src/tools/logic.tools';
import { getPredefinedList, getPredefinedNestedList } from 'src/store/predefinedLists/predefinedLists.getters';

interface Props {
  isSearchable?: boolean;
}

export function SearchableNestedDropdown({ isSearchable }: Props) {
  const { value, script, onChange, error, writeData = [], isDisabled } = useContext(FormParserContext);

  const [setSection] = writeData;

  const { predefinedListName, predefinedNestedListName } = script ?? {};

  const items = useSelector(getPredefinedList)(predefinedListName);

  const nestedItems = useSelector(getPredefinedNestedList)(predefinedNestedListName);

  return (
    <InputContext.Provider
      value={{
        classNames: { container: 'w-100p', input: ifTrue(error, 'with-error') },
        value,
        onChange,
        isDisabled: script.isDisabled || isDisabled,
        isAutoFocus: script.autofocus,
        placeholder: script.placeholder,
        items,
        nestedItems,
        actions: {
          onChangeSection: setSection,
        },
      }}
    >
      <SearchableNestedDropdownComponent isSearchable={isSearchable} />
    </InputContext.Provider>
  );
}
